import React from 'react';
import PropTypes from 'prop-types';
import { Tag } from '@fiverr-private/fit';

const COLORS = {
    BLUE: 'blue',
    PINK: 'pink'
};

const TAGS = {
    NEW: 'New',
    BETA: 'Beta'
};

const BadgeMapping = {
    [TAGS.NEW]: {
        config: {
            color: COLORS.PINK,
            text: TAGS.NEW
        }
    },
    [TAGS.BETA]: {
        config: {
            color: COLORS.BLUE,
            text: TAGS.BETA
        }
    }
};

const Badge = ({ badge }) => {
    const mapping = BadgeMapping[badge];
    if (!mapping) {
        return null;
    }

    const { config: { text, color } } = mapping;

    return <Tag className="badge" kind="hollow" color={color}>{text}</Tag>;
};

Badge.propTypes = {
    badge: PropTypes.string
};

export default Badge;
